import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import "../css/Login.css";

const Login = () => {
  const auth = useContext(AuthContext)!;

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await auth.login(username, password);
      setError("");
    } catch {
      setError("Login fehlgeschlagen");
    }
  };

  if (!!auth.user?.username) {
    return <></>;
  }

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <h2>Login</h2>

      <input
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <input
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button type="submit">Login</button>

      {error && <p className="error">{error}</p>}
    </form>
  );
};

export default Login;
